import { useDispatch } from 'react-redux';
import { PromoCodeDetailInputDto, PromoCodeDetailOutputDto } from '@api/izibizi-xp';
import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useFetch } from '@hooks';
import { saveSuccessServiceResponse, saveUserInput } from '@store';

export const useFetchRetrievePromoCodeDetail = (): UseFetchHookOutput<
	Omit<PromoCodeDetailInputDto, 'metadata'>,
	PromoCodeDetailOutputDto
> => {
	const dispatch = useDispatch();

	return useFetch<PromoCodeDetailInputDto, PromoCodeDetailOutputDto>({
		// old
		// operationKey: 'retrievePromoCodeInformation',
		// new
		operationKey: 'promoCodeDetail',
		onSuccess: (res) => {
			if (res.data) {
				dispatch(saveSuccessServiceResponse({ retrievePromoCodeDetail: res.data }));
				// dispatch(
				// 	saveUserInput({
				// 		promotionalCode:
				// 			res.data.promoCodeStatus === PromoCodeStatus.ACTIVE ? res.data.promoCodeDetail.code : '',
				// 	})
				// );
			}
		},
	});
};
